import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FiEye, FiInfo } from "react-icons/fi";
import { getTrainingManagementStatusClass } from "../CONSTANTS";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import { ACTIVE_MODULE } from "app/_constants/constant";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { isUserVTO } from "../../IncidentManagement/Helper";
import { TRAINING_STATUS, trainingStatusFilterFields } from "../CONSTANTS";
import { getInActiveStaffTrainingList } from "app/_services/ehs/ehsTrainingServices";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import TrainingStatusFilters from "../Assign/Component/TrainingStatusFilters";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import { downloadFileByURL } from "app/_helpers/reactHelper";
import { capitalizeName } from "app/_helpers/helper";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

const ViewInActiveStaffTraining = ({
  match: {
    params: { siteId },
  },
}) => {
  const [trainings, setTrainings] = useState([]);
  const [tableVFLList, setTableVFLList] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filterForm, setFilterForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(1);

  const downloadPdf = async (id) => {
    // const data = await downloadMedicalCertificate(id);
    downloadFileByURL(
      URL_CONFIG.DEV_URL +
        "global-configuration/ehs-module/download-training-certificate/" +
        id,
      `training-certificate-${new Date().toISOString()}.pdf`
    );
  };

  const onReset = () => setFilterForm({ batchName: "", traineeDesignation: "" });

  const onChange = ({ target: { name, value } }) => {
    setFilterForm((prev) => {
      if (name === "traineeTypeView") {
        prev.traineeId = "";
      }
      return { ...prev, [name]: value };
    });
  };

  // ******** useMemo ******
  const sortableColumn = useMemo(() => {
    const column = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "locationName",
        text: "Location",
        sort: true,
      },
      {
        dataField: "currentLocation",
        text: "Current Location",
        sort: true,
      },
      {
        dataField: "traineeTypeView",
        text: "Staff Type",
        sort: true,
      },
      {
        dataField: "traineeID",
        text: "ID",
        sort: true,
      },
      {
        dataField: "traineeName",
        text: "Name",
        sort: true,
        formatter: (index, row) => {
          return <div>{capitalizeName(row?.traineeName)}</div>;
        },
      },
      {
        dataField: "traineeDesignation",
        text: "Designation",
        sort: true,
      },
      {
        dataField: "formA",
        text: "Form A",
        sort: true,
      },
      {
        dataField: "trainingTypeView",
        text: "Training Type",
        sort: true,
      },
      {
        dataField: "trainingCategoryName",
        text: "Skill Category",
        sort: true,
      },
      // {
      //   dataField: "trainingSubCategoryName",
      //   text: "Training Sub-Category",
      //   sort: true,
      // },
      {
        dataField: "ehsSite.name",
        text: "Mines name",
        sort: true,
      },
      {
        dataField: "startDate",
        text: "Start Date",
        sort: true,
        formatter: (startDate) => {
          return DDMMYYYYFormat(startDate);
        },
      },
      {
        dataField: "batchName",
        text: "Batch ID",
        sort: true,
      },
      {
        dataField: "trainingStatusView",
        text: "Status",
        sort: true,
        formatter: (status, row) => {
          return <div className={getTrainingManagementStatusClass(status)}>{status}</div>;
        },
      },
      {
        dataField: "certificateId",
        text: "Certificate",
        sort: true,
        formatter: (id, row) => {
          return (
            <div className="actionIconsGroup">
              {row?.trainingStatus === TRAINING_STATUS.completed && isUserVTO() ? (
                <CustomTooltip tooltip={"Certificate"}>
                  <span
                    onClick={() => downloadPdf(row?.id)}
                    className="icons text-cyanBlue"
                  >
                    <FiInfo style={{ color: "rgb(21 239 21)" }} />
                  </span>
                </CustomTooltip>
              ) : (
                "In Progress"
              )}
            </div>
          );
        },
      },
      {
        dataField: "ID",
        text: "Action",
        sort: true,
        formatter: (cell, row) => {
          return (
            <div className="actionIconsGroup">
              <CustomTooltip tooltip={"View"}>
                <Link
                  to={`${
                    siteId ? "/sites/" + siteId : ""
                  }/health-safety-and-environment/training-management/view/${row.id}`}
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </CustomTooltip>
            </div>
          );
        },
      },
    ];

    return column;
  }, [siteId]);

  useEffect(() => {
    const fetchData = async () => {
      let tabType = tab === 1 ? "unAssigned" : "assigned";
      try {
        const response = await getInActiveStaffTrainingList(tabType);

        if (!response?.data) {
          // Handle the case where data is not received
          setLoading(false);
          return;
        }
        setTrainings(
          Array.isArray(response?.data)
            ? response?.data.map((data) => ({
                ...data,
                locationName: data?.ehsSite ? data?.ehsSite?.name : "",
              }))
            : []
        );
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error as needed, e.g., show an error message
        setLoading(false);
      }
    };
    fetchData();
  }, [tab]);

  useEffect(() => {
    setTableVFLList(
      trainings?.filter?.((data) => {
        let flag = true;
        if (filterForm?.traineeTypeView === "All") flag = true;

        if (flag) {
          for (const key in filterForm) {
            if (
              (key === "traineeTypeView" && filterForm?.traineeTypeView === "All") ||
              !filterForm[key]
            )
              continue;
            if (
              key !== "traineeDesignation" &&
              key !== "batchName" &&
              data[key] !== filterForm[key]
            )
              return (flag = false);
            else if (
              (key === "traineeDesignation" || key === "batchName") &&
              !data[key]?.toLowerCase()?.includes(filterForm[key]?.toLowerCase())
            )
              return (flag = false);
          }

          return (flag = true);
        }

        // if (flag) flag = validateRowFilter(filterForm, data);
        return flag;
      })
    );
  }, [filterForm, trainings]);

  const finalSortableColumn = useMemo(() => {
    return sortableColumn.filter((obj) => {
      return (tab === 1 && obj.dataField !== "currentLocation") || tab === 2;
    });
  }, [sortableColumn, tab]);

  const onTabChange = (num) => {
    if (tab === num) return;
    setTrainings([]);
    setTableVFLList([]);
    setTab(num);
  };

  const tableToolbarBeforeView = () =>
    showFilter && (
      <TrainingStatusFilters
        fields={trainingStatusFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChange}
        onReset={onReset}
        oldStaff
      />
    );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Training Management",
            path: "/health-safety-and-environment/training-management",
          },
          { name: "InActive Staff" },
        ]}
        module={ACTIVE_MODULE.training}
      />
      <br />
      <br />
      <div className="healthSafetyEnvironmentWrapper">
        <div>
          <div className="card p-4 mb-4 overflow-visible">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">{"InActive Staff"}</h3>
              <FilterBtn setShowFilter={setShowFilter} />

              <BackBtn url={`/health-safety-and-environment/training-management`} />
            </div>

            <div className="healthSafetyEnvironmentWrapper EHS_module_tabber mb-3">
              <div className="hseMenuLinks card">
                <a
                  href
                  onClick={() => onTabChange(1)}
                  className={`pointer${tab === 1 ? " active" : ""}`}
                >
                  InActive Unassigned
                </a>

                <a
                  href
                  onClick={() => onTabChange(2)}
                  className={`pointer${tab === 2 ? " active" : ""}`}
                >
                  InActive Assigned
                </a>
              </div>
            </div>

            {!loading ? (
              <>
                <SearchBootstrapTable
                  searchKey={"ViewInActiveStaffSearchTraining"}
                  data={tableVFLList.map((d, idx) => ({ ...d, sid: idx + 1 }))}
                  columns={finalSortableColumn}
                  tableBeforeSearch={tableToolbarBeforeView}
                  tableKey="ViewInActiveStaffTraining"
                />
              </>
            ) : (
              <NetZeroLoader />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewInActiveStaffTraining;
